import { useEffect, useRef, useState } from 'react';

export function useSectionsObserver(sectionStartsRefs, sectionsVisible) {
  // IntersectionObserver options
  const observerOptions = {
    root: null,
    rootMargin: '0px -10% -60% 0px',
    threshold: 0,
  };

  // index of currenltly visible section (value will be send to menu) - state
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  // IntersectionObserver init
  useEffect(() => {
    const observer = new IntersectionObserver(onSectionsVisible, observerOptions);
    if (sectionStartsRefs.current) {
      sectionStartsRefs.current.forEach((ref, key) => {
        const element = ref.current;
        // observe only if section is visible
        if (element && sectionsVisible.indexOf(key) !== -1) observer.observe(element);
      });
    }
    return () => {
      observer.disconnect();
    };
  }, [sectionStartsRefs, sectionsVisible]);

  // last visible sections
  const lastSections = useRef([] as number[]);

  // index of currenltly visible section - ref
  const currentSection = useRef(undefined as number | undefined);

  // IntersectionObserver callback
  const onSectionsVisible = (entries) => {
    let visibleSection: number | undefined;

    // analyze all intersecting sections, determine visibleSeciton
    entries.forEach((entry) => {
      const sectionKey = entry.target.attributes['data-visible-section-index'].value;
      if (entry.isIntersecting) {
        visibleSection = sectionKey;
        visibleSection && lastSections.current.push(visibleSection);
      } else {
        lastSections.current = lastSections.current.filter((value) => value !== sectionKey);
        visibleSection = lastSections.current[lastSections.current.length - 1];
      }
    });

    // set index of currenltly visible section
    if (visibleSection && currentSection.current !== visibleSection) {
      currentSection.current = visibleSection;
      setCurrentSectionIndex(visibleSection);
    }
  };

  return { currentSectionIndex };
}
